// extracted by mini-css-extract-plugin
export default {"container":"EY-z","title":"FY-z","link":"GY-z"};